import {TweenMax} from "gsap/TweenMaxBase";
import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {InteriorDancePartyMusicNotes} from "./InteriorDancePartyMusicNotes";

export class InteriorDanceParty extends PIXI.Container {

    private readonly lights = ["pink", "blue", "yellow"].map((it) => {
        return this.addChild(new PIXI.Sprite(PIXI.utils.TextureCache["delhi/light-" + it]));
    });
    private readonly musicNotes = [1, 2].map(() => {
        return this.addChild(new InteriorDancePartyMusicNotes());
    });

    constructor() {
        super();

        this.lights[0].position.set(-513 / 2, -188 / 2);
        this.lights[1].position.set(-208 / 2, -243 / 2);
        this.lights[2].position.set(-329 / 2, -262 / 2);

        this.musicNotes[0].position.set(-600 / 2, -184 / 2);
        this.musicNotes[1].position.set(390 / 2, -200 / 2);

        const blink = (light: PIXI.Sprite) => {
            TweenMax.to(light, 0.1, {
                alpha: 1,
                repeat: 1,
                repeatDelay: HLF.Random.floatBetween(0.4, 0.8),
                yoyo: true,
                delay: HLF.Random.floatBetween(0.2, 0.6),
                onComplete: () => {
                    blink(light);
                },
            });
        };

        for (const light of this.lights) {
            light.alpha = 0;
            blink(light);
        }

        for (const musicNotes of this.musicNotes) {
            musicNotes.startEmitting();
        }
    }

    public destroy(options?: PIXI.DestroyOptions | boolean) {
        for (const light of this.lights) {
            TweenMax.killTweensOf(light);
        }
        super.destroy(options);
    }
}
